module.exports = __webpack_public_path__ + "img/noauth.49b6e5c9.png";